/* Petala - aparicion suave de secciones al hacer scroll */
(function () {
  document.documentElement.classList.add('pt-js');
  function revelarTodo() {
    document.querySelectorAll('.pt-rise:not(.pt-in)').forEach(function (el) { el.classList.add('pt-in'); });
  }
  function activar() {
    var items = document.querySelectorAll('.pt-rise:not(.pt-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('pt-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var d = parseInt(el.getAttribute('data-pt-delay') || '0', 10);
          setTimeout(function () { el.classList.add('pt-in'); }, d);
          io.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activar);
  } else {
    activar();
  }
  document.addEventListener('shopify:section:load', activar);
  setTimeout(revelarTodo, 2200);
  window.addEventListener('load', function () { setTimeout(revelarTodo, 1200); });
})();

/* Petala - selector de pais/moneda visible en la barra de arriba (movil).
   Shrine lo mete dentro del menu hamburguesa; lo MOVEMOS (no lo copiamos) a la
   fila de iconos para que se vea sin abrir el menu. Al moverlo, el JS del tema
   conserva sus escuchadores y el desplegable sigue funcionando. */
(function () {
  var LIMITE = 750;
  var loc = null, origen = null, iconos = null, movido = false;

  function preparar() {
    if (!loc) {
      loc = document.querySelector('.header-drawer-v2__localization');
      if (loc) origen = loc.parentElement;
    }
    if (!iconos) iconos = document.querySelector('.header .header__icons, header .header__icons');
    return !!(loc && iconos);
  }

  function colocar() {
    if (!preparar()) return;
    var estrecho = window.innerWidth < LIMITE;
    if (estrecho && !movido) {
      loc.classList.add('pt-loc-en-cabecera');
      iconos.insertBefore(loc, iconos.firstChild);
      acortar(true);
      movido = true;
    } else if (!estrecho && movido) {
      acortar(false);
      loc.classList.remove('pt-loc-en-cabecera');
      if (origen) origen.appendChild(loc);
      movido = false;
    }
  }

  // En la barra de arriba no cabe "Mexico | MXN $": dejamos solo la moneda.
  function acortar(corto) {
    var span = loc.querySelector('.localization-v2__button span');
    if (!span) return;
    if (corto) {
      if (!span.dataset.ptLargo) span.dataset.ptLargo = span.textContent.trim();
      var m = span.dataset.ptLargo.match(/([A-Z]{3})/);
      span.textContent = m ? m[1] : span.dataset.ptLargo;
    } else if (span.dataset.ptLargo) {
      span.textContent = span.dataset.ptLargo;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', colocar);
  } else {
    colocar();
  }
  window.addEventListener('resize', colocar, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    loc = null; iconos = null; movido = false; colocar();
  });
})();
